import React from "react";
import { getAppColor } from "@icarius-app/selectors";
import { useSelector } from "react-redux";
import { Button, Typography } from "@material-ui/core";
import { WatchLaterIcon } from "@icarius-icons/";
import { getAssistanceData } from "@icarius-app/selectors";
import { formatDate } from "@icarius-utils/date";
import { getLocalizedString } from "@icarius-localization/strings";
import useIsPathAvailable from "@icarius-utils/hooks/useIsPathAvailable";
import paths from "@icarius-router/paths";

const SecondSection = ({ handleOpenRegisterAssistanceDialog }) => {
    const color = useSelector(getAppColor);
    const assistanceData = useSelector(getAssistanceData);
    const registerAssistanceButtonIsAvailable = useIsPathAvailable(paths.registerAssistanceButton);

    if (!registerAssistanceButtonIsAvailable) return null;

    const getRegisteredString = () => {
        if (assistanceData.latest_registered_date)
            return `${formatDate(assistanceData.latest_registered_date)} ${
                assistanceData.latest_registered_time
            } hrs. - ${
                assistanceData.latest_registered_type === "exit"
                    ? getLocalizedString("exit")
                    : getLocalizedString("entrance")
            }`;
        return getLocalizedString("noRegisteredAssistanceData");
    };

    return (
        <div className="myDesktopUserDataContainer myDesktopHeaderAssistanceContainer">
            <div className="myDesktopUserDataTextContainer">
                <Typography className="whiteText myDesktopTimeTitle">
                    {getLocalizedString("lastAssistanceRegistry")}:
                </Typography>
                <Typography className="whiteText myDesktopTimeData">{getRegisteredString()}</Typography>
                <Button
                    onClick={handleOpenRegisterAssistanceDialog}
                    className="whiteText"
                    variant="contained"
                    startIcon={<WatchLaterIcon htmlColor={color} />}
                >
                    {getLocalizedString("myAssistanceTitle")}
                </Button>
            </div>
        </div>
    );
};

export default SecondSection;
